import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchFavorites } from '../repositories/monolith-python-legacy/ajax/favorites';
export function changeFavorite(_x, _x2, _x3, _x4) {
  return _changeFavorite.apply(this, arguments);
}
function _changeFavorite() {
  _changeFavorite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpApi, params, logger, subdomain) {
    var _yield$fetchFavorites, response, statusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetchFavorites({
            httpApi: httpApi,
            parameters: params,
            config: {
              bodyAsEncodeString: true,
              requestConfig: {
                headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']]
              },
              subdomain: subdomain
            }
          });
        case 3:
          _yield$fetchFavorites = _context.sent;
          response = _yield$fetchFavorites.response;
          statusCode = _yield$fetchFavorites.statusCode;
          if (!(statusCode !== 200 || 'errors' in response)) {
            _context.next = 8;
            break;
          }
          throw response;
        case 8:
          return _context.abrupt("return", response);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          if (logger) {
            logger.error(_context.t0, {
              message: 'Error in change-favorite'
            });
          }
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return _changeFavorite.apply(this, arguments);
}